export default "__VITE_ASSET__ZJzN7flc__"